import { lazy } from "react";

import { Navigate } from "react-router-dom";

import { RVNestedRoutingPage } from "@regal-voice/ui";
import { usePageAvailability } from "App/routes/Hooks/usePageAvilability/usePageAvailability";
import { AppPagePaths } from "App/routes/paths";
import { orchestrationPathResources } from "Pages/orchestration/Pages/orchestrationPaths";

import { CustomFunctionPaths } from "./paths";

import type { RegalRouteObject } from "App/routes/types";

const FunctionListPage = lazy(() => import("./Pages/FunctionListPage/FunctionListPage"));
const FunctionEditPage = lazy(() => import("./Pages/FunctionEditPage/FunctionEditPage"));

export default function CustomFunctionRouter(): JSX.Element {
    const {
        orchestrationPages: { showCustomFunctions },
    } = usePageAvailability();

    if (!showCustomFunctions) {
        return <Navigate to={AppPagePaths.orchestration} replace />;
    }

    return <RVNestedRoutingPage />;
}

export const customFunctionRoute: RegalRouteObject = {
    path: `${orchestrationPathResources.customFunctions}/*`,
    element: <CustomFunctionRouter />,
    hasNestedRoutes: true,
    children: [
        {
            index: true,
            element: <FunctionListPage />,
        },
        {
            path: CustomFunctionPaths.functionDetail,
            element: <FunctionEditPage />,
        },
    ],
};
